<template>
    <el-dialog
      class="approval-history"
      title="处理记录"
      width="670px"
      :visible.sync="visible"
      @close="closePanel"
      @open="open"
      center
      append-to-body>
      <div class="approval-node">
        <table class="table">
          <tr v-for="(approvalComment, index) in approvalCommentHistory" :key="index">
            <td align="center">
              <label class="font" v-if="approvalComment.date == null">已等待{{waitTime}}</label>
              <label class="font" v-else>{{formatter(approvalComment.date)}}</label>
            </td>
            <td align="center" class="has-line">
              <div class="node-name" :class="{'current-node':approvalComment.nodeId === currentNodeId}">
                <label class="font">{{approvalComment.nodeName}}</label>
              </div>
            </td>
            <td>
              <div class="processing-result">
                <label class="font">{{approvalComment.userName}}</label>
                <label class="font action">{{approvalComment.actionName}}</label><br/>
                <label class="font" :title="approvalComment.comment">{{substring(approvalComment.comment)}}</label>
              </div>
            </td>
            <td class="last-td" v-if="showLookBtn || hasCCInfo(approvalComment)">
              <el-button v-if="!checkRestrict && approvalComment.date !== null && showLookBtn" type="text" class="cancel" @click="viewTask(approvalComment.nodeId)">查看</el-button>
              <el-popover
                placement="bottom"
                width="228"
                :disabled="!hasCCInfo(approvalComment)"
                popper-class="approval-comment-ccinfo"
                trigger="click">
                <span>抄送</span>
                <div class="approval-comment-ccinfo-div">
                  <div class="cc-read-users"><span>已阅：</span><span>{{approvalComment.ccReadUsers ? approvalComment.ccReadUsers.join('，') : ''}}</span></div>
                  <div class="cc-noread-users"><span>未阅：</span><span>{{approvalComment.ccNoReadUsers ? approvalComment.ccNoReadUsers.join('，') :''}}</span></div>
                </div>
                <span slot="reference"><i class="el-icon-more" :style="{visibility: hasCCInfo(approvalComment) ? 'visible': 'hidden'}"></i></span>
              </el-popover>
            </td>
          </tr>
        </table>
      </div>
      <div class="cancel-button">
        <el-button class="cancel" type="primary" @click="closePanel">关闭</el-button>
      </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'approval-comment',
  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
      default: false
    },
    approvalCommentHistory: {
      type: Array
    },
    currentNodeId: {
      type: String
    },
    showLookBtn: {
      type: Boolean,
      default: true
    },
    // 是否开启了已办查看限制（为晟融租户专用）
    checkRestrict: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: false,
      timer: {},
      waitTime: ''
    }
  },
  watch: {
    dialogVisible (val) {
      this.visible = val
    }
  },
  methods: {
    open () {
      let time = _.orderBy(this.approvalCommentHistory.filter(m => m.date !== null), 'date', 'desc')[0]
      this.waitTime = this.timeTransformation(parseInt((new Date() - new Date(time.date)) / 1000))
      this.timer = setInterval(() => {
        this.waitTime = this.timeTransformation(parseInt((new Date() - new Date(time.date)) / 1000))
      }, 1000)
    },
    closePanel () {
      clearInterval(this.timer)
      this.$emit('close')
    },
    formatter (date) {
      return moment(new Date(date)).format('YYYY-MM-DD HH:mm:ss')
    },
    timeTransformation (time) {
      // 天
      let day = parseInt(time / 86400)
      // 时
      let hh = parseInt((time % 86400) / 3600)
      // 分
      let mm = parseInt((time % 86400) % 3600 / 60)
      // 秒
      let ss = parseInt((time % 86400) % 3600 % 60)
      if (day !== 0) {
        return `${day > 10 ? day : '0' + day}天${hh > 10 ? hh : '0' + hh}时${mm > 10 ? mm : '0' + mm}分${ss > 10 ? ss : '0' + ss}秒`
      } else {
        return `${hh > 10 ? hh : '0' + hh}时${mm > 10 ? mm : '0' + mm}分${ss > 10 ? ss : '0' + ss}秒`
      }
    },
    substring (str) {
      if (str && str.length > 30) {
        return str.substring(0, 29) + '...'
      } else {
        return str
      }
    },
    viewTask (currentNodeId) {
      this.$emit('viewState', currentNodeId)
    },
    // 是否有知会节点信息
    hasCCInfo (dealRecord) {
      return (dealRecord.ccReadUsers && dealRecord.ccReadUsers.length > 0) || (dealRecord.ccNoReadUsers && dealRecord.ccNoReadUsers.length > 0)
    }
  }
}
</script>

<style lang="scss">
  .approval-history {
    .el-dialog__header {
      height: 44px;
    }
    .el-dialog__body {
      height: 478px;
      padding: 0px;
    }
    .approval-node {
      width: 100%;
      height: 90%;
      overflow: auto;
      .table {
        width: 100%;
        tr {
          height: 50px;
          &:first-child {
            .has-line::after {
              border: none;
            }
          }
          &:last-child {
            .has-line::before {
              border: none;
            }
          }
          td {
            width: 24%;
            position: relative;
            .node-name {
              overflow: hidden;
              width: 120px;
              height: 30px;
              line-height: 26px;
              border: 1px solid var(--primary, #54ABF1);
              border-radius: 4px;
              color: var(--primary, #54ABF1);
            }
            .current-node {
              background-color: var(--light-9, #DFEBFD);
            }
            &.has-line {
              &::before {
                content: "";
                border: 1px solid #EAEAEE;
                display: block;
                position: absolute;
                left: 100px;
                top: calc(100% - (100% - 30px) / 2);
                height: calc((100% - 30px) / 2);
              }
              &::after {
                content: "";
                border: 1px solid #EAEAEE;
                display: block;
                position: absolute;
                left: 100px;
                bottom: calc(100% - (100% - 30px) / 2);
                height: calc((100% - 30px) / 2);
              }
            }
            .processing-result {
              margin-right: 30px;
              .action {
                margin-left: 30px;
              }
            }
            &.last-td {
              width: 10%;
              text-align: center;
              .cancel {
                margin-right: 15px;
              }
              .el-popover__reference{
                .el-icon-more{
                  cursor: pointer;
                  color: #908F97;
                  &:hover{
                    color: var(--primary, #54ABF1);
                  }
                }
              }
            }
          }
        }
      }
    }
    .cancel-button {
      height: 10%;
      text-align: center;
      .cancel {
        width: 104px;
      }
    }
    .font {
      font-size: 12px;
    }
  }
  .approval-comment-ccinfo{
    >span{
      color: var(--primary, #54ABF1);
    }
    .approval-comment-ccinfo-div{
      margin-top: 10px;
      color: #232323;
      span{
        display: table-cell;
      }
      .cc-read-users,.cc-noread-users{
        margin-bottom: 10px;
        span:first-of-type{
          width: 45px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/process/runtime/approval-comment.vue